<template>
    <div class="bot-view">
        <BotViewHeader :bot_allow_sla_monitor="bot_allow_sla_monitor"></BotViewHeader>
        <ChannelFilter
                :channel-list="channels"
                :active-channel="channelSelected"
                :select-channel="selectChannel"
        ></ChannelFilter>
        <v-layout justify-space-between align-center class="tab_chats_filter" ref="tab_chats_filter">
            <div v-for="(tab_item, index) in tab_item_list" :key="index" @click="selectChatTab(tab_item)">
                <div v-if="tab_item.show">
                <v-tooltip right nudge-left="8" nudge-bottom="24" open-delay="0" :disabled="tab_item.name==='all' || customer_count[tab_item.name] <= 999">
                    <v-badge color="red" right class="tab-badge" slot="activator">
                    <template v-slot:badge>
                        <span v-if="tab_item.name!=='all' && customer_count[tab_item.name]>0">
                            {{parseCount(customer_count[tab_item.name])}}
                        </span>
                    </template>

                    <span
                    :style="styleFilterText(customer_count[tab_item.name])"
                    :class="`tab_chats_filter_text ${active_tab.name===tab_item.name?'tab_chats_filter_activate':''}`">
                        {{$t(`${tab_item.name}`)}}
                    </span>

                </v-badge>
                    <span>{{customer_count[tab_item.name]}}</span>
                </v-tooltip>
                </div>
            </div>
        </v-layout>
        <div class="search-customer">
            <div v-if="search_type === 'agent'" style="width: 90%">
              <v-autocomplete
                  clearable
                  :filter="staffListFilter"
                  class="text-none"
                  :return-object="false"
                  v-model="agent_email"
                  :items="staffList"
                  item-text="email"
                  item-value="email"
                  chips
                  height="34"
                  hide-details
                  solo
                  :placeholder="$t('searchByAgent')"
                  flat
                  @change="fetchCustomers"
                  background-color="#F7F7FC"
              >
                <template v-slot:selection="data">
                  <v-chip
                      :key="JSON.stringify(data.item)"
                      :selected="data.selected"
                      :disabled="data.disabled"
                      class="v-chip--select-multi"
                      @click.stop="data.parent.selectedIndex = data.index"
                      @input="data.parent.selectItem(data.item)"
                  >
                    <v-avatar class="accent white--text">
                      {{ data.item.email.slice(0, 1).toUpperCase() }}
                    </v-avatar>
                    {{ data.item.email }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </div>
            <input v-model="search_text"
                   v-else
                   type="text"
                   autocomplete="nope"
                   :placeholder="$t('searchByUser')"
                   ref="search"
                   @keyup.enter="fetchCustomers">
            <v-icon v-if="search_type !== 'agent'" small class="search-customer-icon">mdi-magnify</v-icon>
            <div class="advance-search-icon">
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-icon size="16" :color="`${showSearchByTime? '#004BBA':'#B2B4C6'}`" v-on="on">mdi-settings</v-icon>
                    </template>
                    <v-list>
                        <v-list-tile
                                v-for="(item, index) in advanceSearchItems"
                                :key="index"
                                @click="onAdvanceSearch(index)"
                        >
                            <v-list-tile-title style="font-weight: normal; font-size: 14px">{{ $t(item.title) }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </div>
        <div class="search-by-time" v-if="showSearchByTime">
          <vc-date-picker :locale="$i18n.locale" v-model="fromDate" mode="dateTime" :max-date="today" :marks="masks" is24hr>
            <template v-slot="{ inputValue, inputEvents }">
              <input
                  class="bg-white border px-2 py-1 rounded time-input"
                  :value="inputValue"
                  v-on="inputEvents"
                  :placeholder="$i18n.t('from')"
              />
            </template>
          </vc-date-picker>
          <vc-date-picker :locale="$i18n.locale" v-model="toDate" mode="dateTime" :max-date="today" :min-date="fromDate" :marks="masks" is24hr>
            <template v-slot="{ inputValue, inputEvents }">
              <input
                  class="bg-white border px-2 py-1 rounded time-input"
                  :value="inputValue"
                  v-on="inputEvents"
                  :placeholder="$i18n.t('to')"
              />
            </template>
          </vc-date-picker>
          <v-icon @click="clearSearchByTime" class="ml-1" color="#888A9A" size="16">mdi-close-circle</v-icon>
        </div>
        <div id="select-box" v-if="active_tab.name==='all'">
            <v-select
                        v-model="selectedFilter"
                        height="34"
                        hide-details
                        solo
                        flat
                        background-color="#F7F7FC"
                        :items="selectItems"
                        item-text="label"
            ></v-select>
        </div>
        <v-layout row wrap>
            <v-flex style="min-width: 50%" v-for="(item, index) in active_tab.sub_category_list" :key="index">
                <div :class="`text-xs-center py-2 tab_filter_btn_wrapper ${isActiveTabCategory(item)?'tab_filter_btn_wrapper_activate':''}`"
                     @click="selectCategoryFilter(item)"
                     v-if="botConfig['allowLongWait'] || item.name !=='longWait'">
                    <v-tooltip right nudge-left="8" nudge-bottom="24" open-delay="0" :disabled="!customer_count[item.count_id] || customer_count[item.count_id] <= 999">
                        <v-badge color="red" right class="tab-badge" slot="activator">
                        <template v-slot:badge>
                            <span v-if="customer_count[item.count_id] > 0" >{{parseCount(customer_count[item.count_id])}}</span>
                        </template>
                        <span
                        :style="styleFilterText(customer_count[item.count_id])"
                        :class="`tab_chats_filter_text ${isActiveTabCategory(item)?'tab_chats_filter_activate':''} tab_filter_btn_badge`">
                            {{$t(item.name)}}
                        </span>
                    </v-badge>
                        <span>{{customer_count[item.count_id]}}</span>
                    </v-tooltip>
                </div>
            </v-flex>
        </v-layout>
        <div class="channel-container" v-bind:style="channelContainerStyle()">
            <div id="customer" class="channel-wrapper scroll-y scroll-thin" ref="scroll" v-scroll:#customer="customerOnscroll">
              <RecycleScroller
                  page-mode
                  :items="customersFilter"
                  :item-size="89"
                  key-field="_id"
              >
                <template v-slot="{ item }">
                  <CustomerBox
                      :customer="item"
                      :empty_message="$t(tab.empty_message)">
                  </CustomerBox>
                </template>
                <template #after>
                  <CustomerLoading v-if="loading"/>
                </template>
              </RecycleScroller>
            </div>
        </div>
        <NotificationGroup></NotificationGroup>
    </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import ChannelFilter from "./ChannelFilter";
import BotViewHeader from "components/botview/BotViewHeader";
import BotService from "@/services/bot.service";
import CustomerService from "@/services/customer.service";
import _ from 'lodash';
import utils from "@/services/utils";
import $const from "@/utils/const";
import i18n from "src/plugins/i18n";
import NotificationGroup from "components/botview/NotificationGroup";
import CustomerBox from "@/components/botview/CustomerBox";
import CustomerLoading from "@/components/custom/CustomerLoading";
import moment from "moment";
import StaffService from "@/services/staff.service";
import store from "@/store/store";

export default {
        components: {
            CustomerBox,
            NotificationGroup,
            ChannelFilter,
            BotViewHeader,
            CustomerLoading,
        },
        data() {
            return {
                toDate: null,
                fromDate: null,
                today: moment().format('YYYY-MM-DD'),
                masks: {
                  input: 'DD-MM-YYYY HH:mm',
                },
                textFieldProps: {
                  appendIcon: 'mdi-menu-down',
                  flat: true,
                  solo: true,
                  backgroundColor:"#fffff",
                  hideDetails: true,
                },
                mapNameToType: {
                    'all': 'all',
                    'request': 'request',
                    'yourChat': 'yourChat',
                    'happening': 'support_by_me',
                    'done': 'support_done_by_me',
                    'agentSlaOverdue': 'agent_sla_overdue',
                    'nearAutoClose': 'near_auto_close'
                },
                advanceSearchItems: [
                  { title: 'searchByUser' },
                  { title: 'searchByAgent' },
                  { title: 'searchByTime'}
                ],
                showSearchByTime: false,
                selectedFilter: 'all',
                newMessage: 0,
                tabIsActive: true,
                selectItems: [
                    {label: `${i18n.t('allUsers')}`, value: 'all'},
                    {label: `${i18n.t('chatWithBot')}`, value: 'chat_with_bot'},
                    {label: `${i18n.t('requestSupport')}`, value: 'request_support'},
                    {label: `${i18n.t('beingSupported')}`, value: 'being_supported'},
                    {label: `${i18n.t('beSupported')}`, value: 'be_supported'},
                    {label: `${i18n.t('beMarked')}`, value: 'be_marked'},
                    {label: `${i18n.t('customerIsBlocked')}`, value: 'is_blocked'},
                    {label: `${i18n.t('madBySystem')}`, value: 'is_auto_mad'},

                ],

                active_tab: null,
                customers: [],
                skills: [],
                is_long_wait: false,
                me_sub_category: '',
                type: 'all',
                page: 1,
                next: false,
                customer_count: {
                    request: 0,
                    happening: 0,
                    longWait: 0,
                    done: 0,
                    yourChat: 0,
                    agentSLAOverdue: 0
                },
                search: '',
                agent_email: '',
                search_text: '',
                channels: [],
                token: '',
                search_type: 'user',
                // check to load more customer
                is_loading_customer: false,
                PageTitleNotification : {
                        Vars:{
                            OriginalTitle: document.title,
                            Interval: null
                        },
                        On: function(notification, intervalSpeed){
                            var _this = this;
                            _this.Vars.Interval = setInterval(function(){
                                document.title = (_this.Vars.OriginalTitle == document.title)
                                                    ? notification
                                                    : _this.Vars.OriginalTitle;
                            }, (intervalSpeed) ? intervalSpeed : 2000);
                        },
                        Off: function(){
                            clearInterval(this.Vars.Interval);
                            document.title = this.Vars.OriginalTitle;
                        }
                },
                save_user_notify_new_message:false,
                bot_allow_sla_monitor: "0"
            }
        },
        mounted(){
            this.checkTabIsActive()
            this.loadNotifySetting()
            this.pollingHappening()
            this.$store.state.viewBotView = this;
            this.getAllAgentQuickResponse();
        },
        computed: {
            ...mapState(['notifyBotChat', 'isSmallScreen', 'channelSelected', 'tab', 'botList','bot', 'user', 'staffList', 'botStaffList']),
            ...mapState('config', ['botConfig']),
            ...mapState('customer', ['currentCustomer', 'loading']),
            //...mapActions('agentQuickResponse', ['getAllAgentQuickResponse']),
            staffList() {
              return this.botStaffList.find(o => o.bot_code === this.$router.currentRoute.params.bot_code).staffs;
            },
            customersFilter: function() {
                let key = this.search.trim().toLowerCase();
                let list = this.customers;
                //Filter search
                if (key) {
                    list = _.filter(this.customers, (item) => {
                        if (item.sender_name && this.search_type === 'user') {
                            return item.sender_name.toLowerCase().includes(key)
                        }
                        else if (item.supporter && this.search_type === 'agent') {
                            return item.supporter.email.includes(key)
                        }
                        else return false;
                    })
                }
                //Filter Channel
                list = _.filter(list, o => o.sender_channel === this.channelSelected || this.channelSelected === 'all' || (this.channelSelected==='livechat' && o.sender_channel==='old_livechat'));

                let active_tab = ''
                if (this.active_tab.name === 'request') {
                    active_tab = 'request'
                } else if (this.active_tab.name === 'yourChat') {
                    active_tab = this.me_sub_category
                }
                //Filter tab chat
                if (active_tab === 'request') {
                    list = _.filter(list, o => o.need_support === true)
                }
                if (active_tab === 'happening') {
                    list = _.filter(list, o=> o.supporter && o.supporter.id === this.user.id)
                }
                if (active_tab === 'done') {
                    // list = _.filter(list, o=> o.supporter && o.supporter.id === this.user.id)
                }
                if (active_tab === 'agentSlaOverdue') {
                  list = _.filter(list, o => o.agent_sla_overdue === true);
                }
                if (active_tab === 'nearAutoClose') {
                  list = _.filter(list, o => o.near_auto_close === true);
                }
                if (this.skills && this.skills.length>0) {
                    for (let skill of this.skills) {
                        list = _.filter(list, o => !!_.find(o.request_support_categories, v => v.id === skill))
                    }
                }
                if (this.is_long_wait) {
                    list = _.filter(list, o => o.is_long_wait === true)
                }
                if (this.fromDate && this.toDate) {
                  let fromDateISOUnix = moment(this.fromDate).utc().unix()
                  let toDateISOUnix = moment(this.toDate).utc().unix()
                  list = _.filter(list, function(item) {
                    return _.inRange(
                        moment(item.last_user_interactive_time).unix(),
                        fromDateISOUnix,
                        toDateISOUnix
                    );
                  })
                }
                //Filter advanced search
                switch (this.selectedFilter) {
                    case "all":
                        break;
                    case "chat_with_bot":
                        list = _.filter(list, o => !o.need_support);
                        break;
                    case "request_support":
                        list = _.filter(list, o => o.need_support === true && !o.supporter);
                        break;
                    case "being_supported":
                        list = _.filter(list, o => !!o.supporter);
                        break;
                    case "be_supported":
                        list = _.filter(list, o => !!o.last_supporter);
                        break;
                    case "be_marked":
                        list = _.filter(list, o=> o.need_re_support === true);
                        break;
                    case "is_blocked":
                        list = _.filter(list, o => o.block_status === true);
                        break;
                    case "is_auto_mad":
                        list = _.filter(list, o => o.is_auto_mad === true);
                        break;
                    case "agent_sla_overdue":
                        list = _.filter(list, o => o.agent_sla_overdue === true);
                        break;
                    case "near_auto_close":
                      list = _.filter(list, o => o.near_auto_close === true);
                      break;
                    default:
                      break;
                }
                list = list.sort((cus1, cus2) => {
                    let cus1Date = cus1.last_user_interactive_time ? cus1.last_user_interactive_time : cus1.updated_time;
                    let cus2Date = cus2.last_user_interactive_time ? cus2.last_user_interactive_time : cus2.updated_time;
                    return new Date(cus2Date) - new Date(cus1Date)
                });
                return _.uniqBy(list, '_id.sender_id');
            },
            tab_item_list: function(){
              let tab_item_list = [
                {
                  name: 'all',
                  show: true,
                  empty_message: 'allCustomersEmptyMessage',
                  sub_category_list: []
                }, {
                  name: 'request',
                  show: true,
                  empty_message: 'requestsCustomerEmptyMessage',
                  sub_category_list: [
                    {
                      id: 'longWait',
                      count_id: 'longWait',
                      name: 'longWait',
                      empty_message: 'longWaitEmptyMessage'
                    }
                  ]
                }, {
                  name: 'yourChat',
                  show: true,
                  empty_message: 'requestsCustomerEmptyMessage',
                  sub_category_list: [
                    {
                      id: 'happening',
                      count_id: 'happening',
                      name: 'happening',
                      empty_message: 'yourChatsEmptyMessage'
                    },
                    {
                      id: 'done',
                      count_id: 'done',
                      name: 'done',
                      empty_message: 'yourChatsEmptyMessage'
                    }
                  ]
                },
              ]
              if (this.botConfig && this.botConfig['autoMadConfigs'] && this.botConfig['enableAutoMadV2'] === '1'){
                tab_item_list[2].sub_category_list.push({
                  id: 'nearAutoClose',
                  count_id: 'nearAutoClose',
                  name: 'nearAutoClose',
                  empty_message: 'yourChatsEmptyMessage'
                });
              }
              return tab_item_list;
            },
        },
        watch: {
            newMessage:{
                handler(newVal, oldVal){

                    if(newVal > 0){
                        this.PageTitleNotification.Off()
                        this.PageTitleNotification.On("(" + this.newMessage.toString() + ")" +" New message!")
                        if(newVal > oldVal){
                            this.playSound()
                        }
                    }else{
                        this.PageTitleNotification.Off()
                    }
                }
            },

            '$i18n.locale': {
                handler(val) {
                    this.selectItems = [
                        {label: `${i18n.t('allUsers')}`, value: 'all'},
                        {label: `${i18n.t('chatWithBot')}`, value: 'chat_with_bot'},
                        {label: `${i18n.t('requestSupport')}`, value: 'request_support'},
                        {label: `${i18n.t('beingSupported')}`, value: 'being_supported'},
                        {label: `${i18n.t('beSupported')}`, value: 'be_supported'},
                        {label: `${i18n.t('beMarked')}`, value: 'be_marked'},
                        {label: `${i18n.t('customerIsBlocked')}`, value: 'is_blocked'},
                    ]
            }},
            toDate() {
              if (this.fromDate && this.toDate) {
                this.fetchCustomers();
              }
            },
            fromDate() {
              if (this.fromDate && this.toDate) {
                this.fetchCustomers();
              }
            },
            active_tab: {
                handler(newVal, oldVal) {
                    if (!!oldVal) {
                        this.skills = [];
                        this.is_long_wait = false;
                        this.selectedFilter = 'all';
                        this.fetchData();
                    }
                }
            },
            selectedFilter: {
               handler() {
                   this.fetchData();
               }
            },
            '$route.params.bot_code': {
                handler() {
                    this.getAllAgentQuickResponse();
                    this.newMessage = 0
                    this.$store.dispatch(this.$ActionTypes.CHANNEL, 'all');
                    let old_active_tab = this.active_tab ? this.active_tab.name : null;
                    let new_active_tab;
                    if (StaffService.checkStaffHasRoleFeature(this.$route.params.bot_code, this.user.id, $const.ROLE_FEATURES.ACCESS_LIVE_SUPPORT_PAGE)) {
                        this.tab_item_list[0].show = this.tab_item_list[1].show = true
                        new_active_tab = this.tab_item_list[0]
                    } else {
                        this.tab_item_list[0].show = this.tab_item_list[1].show = false
                        new_active_tab = this.tab_item_list[2]
                    }
                    if (new_active_tab.name !== old_active_tab) {
                        this.selectChatTab(new_active_tab)
                    }
                    if(this.$route.params.bot_code) {
                        this.getListChannels();
                        if (!old_active_tab || new_active_tab.name === old_active_tab) {
                            this.fetchData();
                        }
                        this.loadNotifySetting()
                    }
                },
                immediate: true,
                // deep: true
            },
            "$store.state.botStaffList": {
                handler() {
                    let old_active_tab = this.active_tab ? this.active_tab.name : null;
                    let new_active_tab;
                    if (StaffService.checkStaffHasRoleFeature(this.$route.params.bot_code, this.user.id, $const.ROLE_FEATURES.ACCESS_LIVE_SUPPORT_PAGE)) {
                        this.tab_item_list[0].show = this.tab_item_list[1].show = true
                        new_active_tab = this.tab_item_list[0]
                    } else {
                        this.tab_item_list[0].show = this.tab_item_list[1].show = false
                        new_active_tab = this.tab_item_list[2]
                    }
                    if (new_active_tab.name !== old_active_tab) {
                        this.selectChatTab(new_active_tab)
                    }
                }
            },
            channelSelected: {
                handler() {
                    this.fetchData();
                }
            },
            notifyBotChat(val) {
                switch (val.type) {
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.USER_REQUEST_SUPPORT:
                        this.userRequestSupport(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.USER_NEED_SUPPORT_SEND_MSG:
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.ADMIN_SEND_MSG:
                        this.adminSendMessage(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.USER_SEND_MSG:
                        this.userSendMessage(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.BOT_SEND_MSG:
                        this.botSendMessage(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.MARK_AS_DONE:
                        this.markAsDone(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.ADMIN_ASSIGN_SUPPORT:
                        this.adminAssignSupport(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.MESSAGE_SEEN:
                        this.messageSeen(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.LONG_WAIT:
                        this.userLongWait(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.COUNT_REQUEST_SUPPORT_CHANGED:
                        this.update_request_support_count(val);
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.BLOCK_CUSTOMER_EVENT:
                        this.blockCustomer(val)
                        break;
                    case this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.AGENT_SLA_OVERDUE:
                        this.slaOverdue(val)
                        break;
                    default:
                        break;
                }
            },
            // "$store.state.adminAssignSupport": {
            //     handler() {
            //         console.log(this.$store.state.adminAssignSupport)
            //     }
            // }
        },
        methods: {
            ...mapActions('loading', ['openLoading', 'closeLoading']),
            ...mapActions('customer', ['openLoading', 'closeLoading']),
            ...mapActions('agentQuickResponse', ['getAllAgentQuickResponse']),

            removeVietnameseTones: utils.removeVietnameseTones,
            styleFilterText (customerCount){
                return {'padding-right': '-10px','margin-right':customerCount <= 999 ? (customerCount <= 99 ? (customerCount <= 9 ? '0px':'5px'): '15px'): '25px' }
            },
            pollingHappening() {
              setTimeout(() => {
                if (this.active_tab.name === 'yourChat') {
                  this.fetchCustomersCount()
                  this.fetchCustomers()
                }
                this.pollingHappening()
              }, 30 * 1000)
            },
          staffListFilter(item, queryText, itemText) {
              let key = this.removeVietnameseTones(queryText.trim().toLowerCase());
              if (key) {
                return this.removeVietnameseTones(item.name.toLowerCase()).includes(key) || this.removeVietnameseTones(item.email.toLowerCase()).includes(key)
              }
              return false
            },
            clearSearchByTime() {
              this.fromDate = null;
              this.toDate = null;
              this.showSearchByTime = false
              this.fetchCustomers()
            },
            checkTabIsActive(){
             document.addEventListener("visibilitychange", (event) => {
                if (document.visibilityState == "visible") {
                    this.tabIsActive = true
                }
                else {
                    this.tabIsActive = false
                }
                });
            },
            loadNotifySetting() {
                this.openLoading();
                BotService.getBotNotifySetting(this.$route.params.bot_code).then(response => {
                    this.save_user_notify_new_message = response.data.save_user_notify_new_message === "1";
                }).catch(() => {
                    // this.$AppService.toastError("get notification setting failed.");
                    this.save_user_notify_new_message = false;
                }).finally(() => {
                    this.closeLoading()
                })
            },
            playSound(){
                return new Promise((resolve, reject) => {
                    try{
                        let soundSource = "/../../assets/audio/messeage_notify.mp3";
                        let sound = new Audio(soundSource);
                        sound.onended = () => {
                            resolve();
                        };
                        sound.play();
                    }catch(error){
                        reject(error);
                    }
                });
            },

            checkNewMessage(sender_id){
                // let unseenCustomer = this.customers.find(customer => customer.seen === false && customer.supporter && customer.supporter.id === this.user.id);

                let unseenNumber = 0
                this.customers.forEach(customer => {
                    if(customer.seen === false && customer.supporter && customer.supporter.id === this.user.id){
                        unseenNumber+=1;
                    }
                })
                let current_sender_id = this.currentCustomer._id ? this.currentCustomer._id.sender_id : null
                if( this.newMessage != unseenNumber && this.save_user_notify_new_message == true && (!sender_id || this.tabIsActive == false || current_sender_id != sender_id)){
                    this.newMessage = unseenNumber
                }
            },
            onAdvanceSearch(idx) {
              switch (idx) {
                case 0:
                  this.search_type = 'user'
                  break;
                case 1:
                  this.search_type = 'agent'
                  break;
                case 2:
                  this.showSearchByTime = true;
                  break;
                default:
                  break;

              }
            },
            webviewPostMessage() {
                let me = this.user ? this.user : null
                if (me && window.ReactNativeWebView) {
                    let meStr = me['id'] ? 'id=' + me['id'] : ''
                    meStr += me['name'] ? '|name=' + me['name'] : ''
                    meStr += me['email'] ? '|email=' + me['email'] : ''
                    meStr += me['phone'] ? '|phone' + me['phone'] : ''
                    meStr += me['jti'] ? '|jti=' + me['jti'] : ''
                    window.ReactNativeWebView.postMessage(meStr)
                }
            },
            scrollTop () {
                let scroll = this.$refs.scroll
                if (scroll) {
                    scroll.scrollTop = 0
                }
            },
            fetchData() {
                //Get All customer
                if (this.$route.params.bot_code) {
                    this.fetchSkillData();
                    this.fetchCustomersCount();
                    this.fetchCustomers();
                    this.webviewPostMessage();
                }
            },
            fetchCustomers() {
                this.openLoading();
                this.page = 1;
                this.search = this.search_text;
                let type = this.type
                if (this.active_tab.name === 'yourChat') {
                    type = this.mapNameToType[this.me_sub_category]
                }
                CustomerService.getCustomers(
                    this.$route.params.bot_code,
                    this.channelSelected,
                    this.search,
                    this.agent_email,
                    this.search_type,
                    type,
                    this.skills,
                    this.is_long_wait,
                    this.selectedFilter,
                    this.fromDate,
                    this.toDate,
                    this.page
                )
                    .then((result)=> {
                        for (let customer of result.data.results) {
                            customer.bot_answer_last = customer.last_chatlog_source === this.$const.CHATLOG_SOURCE.SEND
                                && [this.$const.CHATLOG_TYPE.NORMAL, this.$const.CHATLOG_TYPE.SEND_BROADCAST, this.$const.CHATLOG_TYPE.SEND_REMINDER].includes(customer.last_chatlog_type);
                        }
                        this.customers = result.data.results;
                        this.next = !!result.data.next;
                        this.page = result.data.current_page;
                        this.closeLoading()
                    })
            },
            fetchCustomersCount() {
                CustomerService.getCustomersCount(this.$route.params.bot_code)
                    .then((result)=> {
                        this.customer_count = result.data
                    })
            },
            fetchSkillData() {
                BotService.getAutoAssignStatus_manage(this.$route.params.bot_code)
                    .then((result)=> {
                        let categories = result.data.rs_categories;
                        categories = _.map(categories, o=> {
                            return {name: o.name, id: o.id, count_id: 'category:' + o.id, empty_message: 'yourChatsEmptyMessage'}
                        });
                        categories.push({name: 'longWait', id: 'longWait', count_id: 'longWait', empty_message: 'longWaitEmptyMessage'});
                        if (this.active_tab.name ==='request') {
                          this.active_tab.sub_category_list = categories
                        }
                        const item = {
                          id: 'agentSlaOverdue',
                          count_id: 'agentSlaOverdue',
                          name: 'agentSlaOverdue',
                          empty_message: 'longWaitEmptyMessage'
                        };
                        BotService.getSLAConfigs(this.$route.params.bot_code).then((response) => {
                        if(response.data.bot_allow_sla_monitor){
                            this.bot_allow_sla_monitor = response.data.bot_allow_sla_monitor
                        }
                        if (response.data.enable && response.data.enable === '1' && this.active_tab.name === 'yourChat') {
                          let id = -1;
                          for (let doc of this.active_tab.sub_category_list) {
                            if (doc.id === item.id) {
                              id = 1
                            }
                          }
                          if (id < 0) {
                            this.active_tab.sub_category_list.push(item);
                          }
                        }else{
                          let id = -1;
                          for (let i = 0; i < this.active_tab.sub_category_list.length; i++) {
                            if (this.active_tab.sub_category_list[i].id === item.id) {
                              id = i
                            }
                          }
                          if (id > -1) {
                            this.active_tab.sub_category_list.splice(id, 1)
                          }

                        }
                      });
                    })
            },
            parseCount(count) {
                return count > 999 ? '999+' : count
            },
            getListChannels() {
                BotService.getListChannels(this.$route.params.bot_code).then((list_channels) => {
                    this.channels = utils.smoothListChannels(list_channels.data.channels);
                });
            },
            bottomVisible(e) {
                return e.target.scrollTop >= e.target.scrollHeight - e.target.offsetHeight -5
            },
            addCustomers(customerToAdd) {
                this.customers = _.union(this.customers, customerToAdd)
            },
            customerOnscroll(e) {
                if (this.bottomVisible(e) && !this.is_loading_customer) {
                    if (this.next) {
                        this.is_loading_customer = true;
                        this.openLoading()
                        this.page = this.page + 1;
                        let type = this.type
                        if (this.active_tab.name === 'yourChat') {
                            type = this.mapNameToType[this.me_sub_category]
                        }
                        CustomerService.getCustomers(this.$route.params.bot_code, this.channelSelected, this.search, this.agent_email, this.search_type, type, this.skills, this.is_long_wait, this.selectedFilter,this.fromDate,
                            this.toDate, this.page)
                            .then((result)=> {
                                this.is_loading_customer = false;
                                this.addCustomers(result.data.results);
                                this.next = !!result.data.next
                                this.closeLoading()
                            })
                    }
                }
            },
            userRequestSupport(val) {
                let bot_code = val.data.bot_code;
                let sender_id = val.data.sender_id;
                let channel = val.data.channel;
                let sender_name = val.data.sender_name;
                let app_sender = val.data.app_sender;
                let request_support_categories = val.data.request_categories;
                let idxCustomer = _.findIndex(this.customers, o => o._id.sender_id === sender_id);
                if (idxCustomer > -1) {
                    let customer = this.customers[idxCustomer];
                    customer.need_support = true;
                    customer.request_support_categories = request_support_categories;
                    customer.seen = false;
                    this.customers.splice(idxCustomer, 1);
                    this.customers.unshift(customer);
                }
                else if (this.active_tab.name !=='yourChat'){
                  this.customers.unshift(app_sender)
                }
            },
            userLongWait(val) {
                let sender_id = val.data.sender_id;
                let app_sender = val.data.app_sender;
                let idxCustomer = _.findIndex(this.customers, o => o._id.sender_id === sender_id);
                if (idxCustomer <= -1 && this.me_sub_category==="longWait") {
                  this.customers.unshift(app_sender);
                }
                this.$set(this.customer_count, "longWait", this.customer_count.longWait + 1)
            },
            userSendMessage(val) {
                let bot_code = val.data.bot_code;
                let sender_id = val.data.sender_id;
                let message = val.data.message;
                let channel = val.data.channel;
                let timestamp = val.data.timestamp;
                let sender_name = val.data.sender_name;
                let supporter = val.data.supporter;
                if (this.currentCustomer.block_status) {
                  return;
                }
                //New channel
                if (!this.channels.includes(channel)) {
                    this.channels.push(channel)
                    this.channels = utils.smoothListChannels(this.channels);
                }
                let idxCustomer = _.findIndex(this.customers, o => o._id.sender_id === sender_id);
                if (idxCustomer > -1) {
                    let customer = this.customers[idxCustomer];
                    customer.last_message = JSON.stringify(message);
                    customer.updated_time = timestamp;
                    customer.bot_answer_last = false;
                    customer.last_user_interactive_time = timestamp;
                    customer.last_chatlog_source = this.$const.CHATLOG_SOURCE.RECEIVE;
                    customer.last_chatlog_type = this.$const.CHATLOG_TYPE.NORMAL;
                    customer.last_user_chatlog = {
                        "message": customer.last_message,
                        "created_time":  new Date().toISOString(),
                        "status": 1,
                    };
                    // customer_of_all.seen = !this.isNeedSupport(customer_of_all);
                    customer.seen = false;
                    this.checkNewMessage(sender_id)
                    this.customers.splice(idxCustomer, 1);
                    this.customers.unshift(customer);
                }
                else if (this.active_tab.name !=='yourChat' && this.active_tab.name !== 'request'){
                    const newCustomer= {
                      _id: {
                        sender_id: sender_id,
                        app_code: bot_code,
                      },
                      sender_channel: channel,
                      sender_name: sender_name,
                      supporter: supporter,
                      need_support: false,
                      last_message: JSON.stringify(message),
                      updated_time: timestamp,
                      bot_answer_last: false,
                      last_user_interactive_time: timestamp,
                      last_chatlog_source: this.$const.CHATLOG_SOURCE.RECEIVE,
                      last_chatlog_type: this.$const.CHATLOG_TYPE.NORMAL,
                      last_user_chatlog: {
                        "message": JSON.stringify(message),
                        "created_time":  new Date().toISOString(),
                        "status": 1,
                      },
                      seen: false
                    }
                    this.customers.unshift(newCustomer)
                }
            },
            adminSendMessage(val) {
                let val_data = val.data;
                let message_type = val.msg_type;
                if (!message_type && !!val_data && !!val.data.message) {
                    message_type = val.data.message.type;
                }
                let message_content = val.content;
                if (!message_content && !!val_data && !!val.data.message) {
                    message_content = val_data.message.content;
                }
                let sender_id = val.sender_id;
                if (!sender_id && !!val_data) {
                    sender_id = val_data.sender_id;
                }
                let timestamp = val.timestamp;
                if (!timestamp && !!val_data && !!val_data.timestamp) {
                    try {
                        timestamp = new Date(val_data.timestamp).toISOString();
                    } catch (e) {
                        timestamp = new Date().toISOString();
                    }
                }
                let idxCustomer = _.findIndex(this.customers, o => o._id.sender_id === sender_id);
                if (idxCustomer > -1) {
                    let customer = this.customers[idxCustomer];
                    if (customer.is_long_wait) {
                        //Update customer count
                        let longWaitCount = this.customer_count.longWait > 0 ? (this.customer_count.longWait - 1) : 0;
                        this.$set(this.customer_count, "longWait", longWaitCount);
                    }
                    customer.is_long_wait = false;
                    customer.last_message = JSON.stringify({
                        type: message_type,
                        content: message_content
                    });
                    customer.updated_time = timestamp;
                    customer.last_supporter_chatlog = {
                        "message": customer.last_message,
                        "created_time":  new Date().toISOString(),
                        "status": 1,
                    };
                    customer.bot_answer_last = false;
                    customer.last_chatlog_source = this.$const.CHATLOG_SOURCE.SEND;
                    customer.last_chatlog_type = this.$const.CHATLOG_TYPE.ADMIN;
                    this.$set(this.customers, idxCustomer, customer );
                }
            },
            botSendMessage(val) {
                let sender_id = val.data.sender_id;
                let message = val.data.message;
                let timestamp = val.data.timestamp;
                let idxCustomer = _.findIndex(this.customers, o => o._id.sender_id === sender_id);
                const MessageType = $const.MSG_TYPE;
                if (idxCustomer > -1
                    && [MessageType.TEXT, MessageType.IMAGE, MessageType.CAROUSEL, MessageType.QUICK_REPLY,
                        MessageType.PAYLOAD, MessageType.FILE, MessageType.ZALO_LIST_TEMPLATE,
                        MessageType.STICKER].includes(message.type)) {
                    let customer = this.customers[idxCustomer];
                    customer.last_message = JSON.stringify(message);
                    customer.updated_time = timestamp;
                    customer.seen = false
                    customer.updated_time = timestamp;
                    customer.last_bot_chatlog = {
                        "message": customer.last_message,
                        "created_time":  new Date().toISOString(),
                        "status": 1,
                    };
                    customer.bot_answer_last = true;
                    customer.last_chatlog_source = this.$const.CHATLOG_SOURCE.SEND;
                    customer.last_chatlog_type = this.$const.CHATLOG_TYPE.NORMAL;
                }
            },
            markAsDone(val) {
                let sender_id = val.data.sender_id;
                let idxCustomer = _.findIndex(this.customers, o => o._id.sender_id === sender_id);
                if (idxCustomer > -1) {
                    this.customers[idxCustomer].need_support = undefined;
                    this.customers[idxCustomer].livesupport_log = undefined;
                    this.customers[idxCustomer].supporter = undefined;
                    this.customers[idxCustomer].last_supporter = val.data.last_supporter;
                    this.customers[idxCustomer].request_support_categories = [];
                    this.customers[idxCustomer].is_long_wait = false;
                    this.customers[idxCustomer].agent_sla_overdue = false;
                }
            },
            adminAssignSupport(val) {
                let sender_id = val.data.sender_id,
                    customer = val.data['app_sender'];
                let idxCustomer = _.findIndex(this.customers, o => o._id.sender_id === sender_id);
                if (idxCustomer > -1) {
                    if (this.me_sub_category === "done") {
                        this.$delete(this.customers, idxCustomer)
                    }
                    else {
                        this.$set(this.customers,idxCustomer, customer)
                    }
                }
                else if (this.me_sub_category === "happening" || this.active_tab.name ==='request') {
                    this.customers.unshift(customer)
                }
                this.$forceUpdate();
            },
            slaOverdue(val) {
                let customer = val.data['app_sender'];
                let active_tab = ''
                if (this.active_tab.name === 'request') {
                    active_tab = 'request'
                } else if (this.active_tab.name === 'yourChat') {
                    active_tab = this.me_sub_category
                }
                if (active_tab === 'agentSlaOverdue') {
                    this.customers.unshift(customer)

                }
                // let agentSlaOverdue = this.customer_count.agentSlaOverdue + 1
                this.fetchCustomersCount();
                // this.$set(this.agentSlaOverdue, "agentSlaOverdue", agentSlaOverdue);
                this.$forceUpdate();
            },
            messageSeen(val) {
                let sender_id = val.data.sender_id;
                this.markSeen(this.customers, sender_id);
            },
            markSeen(customers, sender_id) {
                return _.map(customers, (request_customer) => {
                    if (request_customer._id.sender_id === sender_id) {
                        request_customer.seen = true
                        this.checkNewMessage()
                    }
                    return request_customer
                });
            },
            blockCustomer(val) {
              let sender_id = val.data.sender_id;
              let idxCustomer = _.findIndex(this.customers, o => o._id.sender_id === sender_id);
              let customer = this.customers[idxCustomer];
              customer.block_status = val.data.block_status;
              this.$set(this.customers, idxCustomer, customer );
            },
            toStatistic() {
                this.$router.push('/statistic/' + this.$route.params.bot_code)
            },
            selectChannel(channel) {
                this.scrollTop();
                this.$store.dispatch(this.$ActionTypes.CHANNEL, channel);
            },
            selectChatTab(tab) {
              let old_active_tab = this.active_tab ? this.active_tab.name:null,
                    old_type = this.type,
                    old_me_sub_category = this.me_sub_category;
                this.active_tab = tab
                if (this.active_tab.name === 'yourChat') {
                    this.is_long_wait = false
                }
                this.scrollTop();
                switch (tab.name) {
                    case 'all':
                        this.type ='all';
                        break;
                    case 'request':
                        this.type = 'request';
                        break;
                    case 'yourChat':
                        this.type = 'yourChat';
                        this.me_sub_category = 'happening';
                        break;
                    case 'happening':
                        this.type = 'support_by_me';
                        break;
                    case 'done':
                        this.type = 'support_done_by_me';
                        break;
                    case 'agentSlaOverdue':
                        this.type = 'agent_sla_overdue';
                        break;
                    case 'nearAutoClose':
                      this.type = 'near_auto_close';
                      break;
                    default:
                        break;
                }
                if (old_active_tab === this.active_tab.name && (old_type !== this.type || old_me_sub_category !== this.me_sub_category)) {
                    this.fetchData(); // if active_tab not change -> not trigger watch method
                }
            },
            selectCategoryFilter(val) {
              if (val.name === 'longWait') {
                  this.is_long_wait = !this.is_long_wait
              } else if (this.active_tab.name === 'yourChat') {
                  this.me_sub_category = val.name;
              } else if (!this.skills.find(o => o === val.id)){
                  this.skills.push(val.id)
              } else {
                  let index = this.skills.indexOf(val.id);
                  if (index>-1) {
                      this.skills.splice(index, 1)
                  }
              }
              this.fetchData();
            },
            isActiveTabCategory(val) {
                if (this.active_tab.name === 'yourChat') {
                    return val.name === this.me_sub_category
                }
                return (val.name === 'longWait' && this.is_long_wait === true) || !!_.find(this.skills, o => o === val.id);
            },
            isNeedSupport(customer) {
                return customer['need_support'] !== undefined
            },
            channelContainerStyle() {
                let headerHeight = 0;
                if (this.active_tab.name !== 'all') {
                    headerHeight = headerHeight + (60 + 70 + 40 + 50 + Math.ceil(this.active_tab.sub_category_list.length / 2) * 40)
                }
                else {
                    headerHeight = headerHeight + 60 + 70 + 40 + 50 + 50;
                }
                if (this.showSearchByTime) {
                    headerHeight = headerHeight + 50;
                }
              return `height: calc(100% - ${headerHeight}px)`;
            },
            update_request_support_count(val) {
                let count_data = val.data.count_data;
                for (let [key, value] of Object.entries(count_data)) {
                    this.customer_count[key] = value;
                    if (key.startsWith("supporter:")) {
                        let me = this.user ? this.user : null
                        if (key === ("supporter:" + me.id)) {
                            this.customer_count.yourChat = value;
                            this.customer_count.happening = value;
                        }else if(key === ("supporter:" + me.id+ ":sla_overdue")){
                            this.customer_count.agentSlaOverdue = value
                        }else if(key === ("supporter:" + me.id+ ":near_auto_close")){
                          if (this.customer_count.nearAutoClose !== value) {
                            this.fetchCustomersNoLoading()
                          }
                          this.customer_count.nearAutoClose = value
                        }
                    }
                }
            },
            fetchCustomersNoLoading() {
            this.page = 1;
            this.search = this.search_text;
            let type = this.type
            if (this.active_tab.name === 'yourChat') {
              type = this.mapNameToType[this.me_sub_category]
            }
            CustomerService.getCustomers(
                this.$route.params.bot_code,
                this.channelSelected,
                this.search,
                this.agent_email,
                this.search_type,
                type,
                this.skills,
                this.is_long_wait,
                this.selectedFilter,
                this.fromDate,
                this.toDate,
                this.page
            )
                .then((result)=> {
                  for (let customer of result.data.results) {
                    customer.bot_answer_last = customer.last_chatlog_source === this.$const.CHATLOG_SOURCE.SEND
                        && [this.$const.CHATLOG_TYPE.NORMAL, this.$const.CHATLOG_TYPE.SEND_BROADCAST, this.$const.CHATLOG_TYPE.SEND_REMINDER].includes(customer.last_chatlog_type);
                  }
                  this.customers = result.data.results;
                  this.next = !!result.data.next;
                  this.page = result.data.current_page;
                })
          },
        }
    }
</script>
<style scoped lang="scss" src="../style/bot-view.scss"></style>
